<template>
  <div class="big diagnosis-coupon">
    <div class="page_title">诊疗优惠券</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <div class="top-header">
          <div class="search-box">
            <!-- 优惠券名称 -->
            <div class="item">
              <span>优惠券名称</span>
              <div class="item-content">
                <el-input
                  v-model="searchForm.coupon_name"
                  size="small"
                  clearable
                  @keyup.enter.native="seachEnterFun"
                  placeholder="请输入"
                ></el-input>
              </div>
            </div>

            <!-- 优惠券类型 -->
            <div class="item">
              <span style="padding-left: 8px">优惠券类型</span>
              <div class="item-content">
                <el-select
                  v-model="searchForm.coupon_type"
                  size="small"
                  placeholder="请选择"
                  clearable
                  @change="seachEnterFun"
                >
                  <el-option
                    v-for="item in couponTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>

            <!-- 状态 -->
            <div class="item">
              <span style="margin-left: 10px">状态</span>
              <div class="item-content">
                <el-select
                  v-model="searchForm.status"
                  size="small"
                  placeholder="请选择"
                  @change="seachEnterFun"
                >
                  <el-option
                    v-for="item in statusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
              <el-button
                type="primary"
                size="small"
                style="margin-left: 20px"
                @click="getList"
                >查询</el-button
              >
              <el-button size="small" @click="restBtn">重置</el-button>
            </div>
          </div>
          <!-- 新增活动 -->
          <div style="margin-bottom: 10px">
            <el-button
              type="primary"
              size="medium"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1598') : false
              "
              @click="addOrEditBtn(1)"
              >添加优惠券</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            v-loading="tableLoading"
            :data="diagnosisCouponData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              v-for="item in tableHeader"
              :key="item.prop"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
              :fixed="item.fixed"
            >
              <template slot-scope="scope">
                <div v-if="item.prop == 'sort'">
                  <!-- {{ scope.row[item.prop] }} -->
                  <el-input-number
                    v-model="scope.row[item.prop]"
                    size="small"
                    :min="0"
                    :precision="0"
                    :controls="false"
                    style="width: 90px"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1601')
                        : false
                    "
                    @blur="updateCouponSort(scope.row)"
                  ></el-input-number>
                </div>

                <div v-else-if="item.prop == 'create_time'">
                  {{ scope.row[item.prop] | dateTimeFormat }}
                </div>

                <div v-else-if="item.prop == 'show_time'">
                  {{ scope.row["show_start_time"] | dateFormat }} -
                  {{ scope.row["show_end_time"] | dateFormat }}
                </div>
                <div v-else-if="item.prop == 'total'">
                  {{ scope.row[item.prop] | totalText }}
                </div>
                <div v-else-if="item.prop == 'receive_total'">
                  <el-link type="primary" @click="toDetails(scope.row, 1)">{{
                    scope.row[item.prop]
                  }}</el-link>
                </div>
                <div v-else-if="item.prop == 'use_total'">
                  <el-link type="primary" @click="toDetails(scope.row, 2)">{{
                    scope.row[item.prop]
                  }}</el-link>
                </div>
                <div v-else-if="item.prop == 'max_get_num'">
                  {{ scope.row[item.prop] | maxGetNumText }}
                </div>
                <div v-else-if="item.prop == 'is_share'">
                  {{ scope.row[item.prop] == 1 ? "可分享" : "不可分享" }}
                </div>

                <div v-else-if="item.prop == 'is_overdue'">
                  {{ scope.row[item.prop] | isOverdueText }}
                </div>
                <div v-else-if="item.prop == 'is_send'">
                  {{ scope.row[item.prop] | isEendText }}
                </div>
                <div v-else-if="item.prop == 'coupon_status'">
                  {{ scope.row[item.prop] | couponStatusText }}
                </div>
                <div v-else>
                  {{ scope.row[item.prop] }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="220"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="medium"
                  @click="addOrEditBtn(2, scope.row.coupon_data_id)"
                  :disabled="
                    module_id_array[0]
                      ? !module_id_array.includes('1600')
                      : false
                  "
                  >查看</el-button
                >
                <template v-if="scope.row.is_overdue != 1">
                  <el-button
                    v-if="
                      scope.row.is_send == 1 && scope.row.coupon_status == 1
                    "
                    type="text"
                    size="medium"
                    @click="issueBtn(scope.row.coupon_data_id)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1960')
                        : false
                    "
                    >发放</el-button
                  >

                  <el-button
                    type="text"
                    @click="addOrEditBtn(3, scope.row.coupon_data_id)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1599')
                        : false
                    "
                    >编辑</el-button
                  >

                  <el-button
                    v-if="!scope.row.is_send"
                    type="text"
                    @click="isSendBtn(1, scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1603')
                        : false
                    "
                    >恢复</el-button
                  >

                  <el-button
                    v-else
                    type="text"
                    @click="isSendBtn(2, scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1603')
                        : false
                    "
                    >停发</el-button
                  >

                  <el-button
                    v-if="!scope.row.coupon_status"
                    type="text"
                    @click="isUseBtn(1, scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1602')
                        : false
                    "
                    >启用</el-button
                  >
                  <el-button
                    v-else
                    type="text"
                    @click="isUseBtn(2, scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1602')
                        : false
                    "
                    >禁用</el-button
                  >
                  <el-button
                    type="text"
                    @click="lookLog(scope.row)"
                    :disabled="
                      module_id_array[0]
                        ? !module_id_array.includes('1959')
                        : false
                    "
                    >发放记录</el-button
                  >
                </template>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页 -->
        <pagination
          v-show="totalNum > 0"
          :total="totalNum"
          :page.sync="pagination.page"
          :limit.sync="pagination.pageNumber"
          @pagination="getList"
        />
      </div>
    </div>
    <!-- 优惠券详情 -->
    <el-dialog title="详情" :visible.sync="couponVisible" width="1400px">
      <div style="padding: 20px 20px 0">
        <div class="search-box">
          <!-- 优惠券名称 -->
          <div class="item">
            <span>优惠券名称</span>
            <div class="item-content">
              <el-input
                v-model="couponVisibleForm.coupon_name"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 领取来源 -->
          <div class="item">
            <span style="padding-left: 8px">领取来源</span>
            <div class="item-content">
              <el-select
                v-model="couponVisibleForm.get_type"
                size="small"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in getTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 优惠券当前状态 -->
          <div class="item">
            <span style="margin-left: 10px">优惠券当前状态</span>
            <div class="item-content">
              <el-select
                v-model="couponVisibleForm.used"
                size="small"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in usedOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 领取用户手机号 -->
          <div class="item">
            <span style="margin-left: 10px">领取用户手机号</span>
            <div class="item-content">
              <el-input
                v-model="couponVisibleForm.phone"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="searchCouponVisibleList"
              >查询</el-button
            >
          </div>
        </div>
        <el-table
          v-loading="couponVisibleTableLoading"
          :data="couponVisibleTableData"
          :key="Math.random()"
          height="530px"
          border
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in couponVisibleTableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'get_time'">
                {{ scope.row[item.prop] | dateTimeFormat }}
              </div>

              <div v-else-if="item.prop == 'get_type'">
                {{ scope.row[item.prop] | getTypeText }}
                <span v-if="scope.row[item.prop] == 9"
                  >({{ scope.row.patient_name }})</span
                >
              </div>
              <div v-else-if="item.prop == 'used'">
                {{ scope.row[item.prop] | usedText }}
              </div>
              <div v-else>
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="couponVisibleTotalNum > 0"
        :total="couponVisibleTotalNum"
        :page.sync="couponVisiblePagination.page"
        :limit.sync="couponVisiblePagination.pageNumber"
        @pagination="getUserCouponList"
      />
    </el-dialog>

    <!-- 发放记录 -->
    <el-dialog title="发放记录" :visible.sync="sendLogVisible" width="1300px">
      <div style="padding: 20px 20px 0">
        <div class="search-box">
          <!-- 优惠券名称 -->
          <div class="item">
            <span>优惠券名称</span>
            <div class="item-content">
              <el-input
                v-model="sendLogVisibleForm.coupon_name"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </div>
          </div>

          <!-- 发放时间 -->
          <div class="item">
            <span style="padding-left: 8px">发放时间</span>
            <div class="item-content">
              <el-date-picker
                v-model="sendLogVisibleForm.time"
                size="small"
                type="daterange"
                align="right"
                unlink-panels
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="searchsendLogVisibleList"
              >
              </el-date-picker>
            </div>
          </div>

          <!-- 发放人 -->
          <div class="item">
            <span style="margin-left: 10px">发放人</span>
            <div class="item-content">
              <el-input
                v-model="sendLogVisibleForm.send_content"
                size="small"
                clearable
                placeholder="请输入"
              ></el-input>
            </div>
            <el-button
              type="primary"
              size="small"
              style="margin-left: 20px"
              @click="searchsendLogVisibleList"
              >查询</el-button
            >
          </div>
        </div>
        <el-table
          v-loading="sendLogVisibleTableLoading"
          :data="sendLogVisibleTableData"
          :key="Math.random()"
          height="530px"
          border
          tooltip-effect="dark"
          :header-cell-style="{ background: '#F5F5F5' }"
        >
          <el-table-column
            v-for="item in sendLogVisibleTableHeader"
            :key="item.prop"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :fixed="item.fixed"
          >
            <template slot-scope="scope">
              <div v-if="item.prop == 'create_time'">
                {{ scope.row[item.prop] | dateTimeFormat }}
              </div>

              <div v-else-if="item.prop == 'send_type'">
                {{ scope.row[item.prop] | send_typeText }}
              </div>

              <div v-else-if="item.prop == 'send_content'">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="scope.row[item.prop]"
                  placement="top"
                >
                  <div
                    style="
                      width: 200px;
                      display: -webkit-box;
                      -webkit-line-clamp: 3;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    "
                  >
                    {{ scope.row[item.prop] }}
                  </div>
                </el-tooltip>
              </div>

              <div v-else>
                {{ scope.row[item.prop] }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="sendLogVisibleTotalNum > 0"
        :total="sendLogVisibleTotalNum"
        :page.sync="sendLogVisiblePagination.page"
        :limit.sync="sendLogVisiblePagination.pageNumber"
        @pagination="couponDataSendLog"
      />
    </el-dialog>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10,
      },
      couponTypeOptions: [
        {
          value: 1,
          label: "药品减免券",
        },
        // {
        //   value: 2,
        //   label: "药品折扣券",
        // },
        {
          value: 3,
          label: "问诊减免券",
        },
        {
          value: 4,
          label: "问诊折扣券",
        },
        {
          value: 5,
          label: "运费全减券 ",
        },
        {
          value: 6,
          label: "VIP陪诊券 ",
        },
        {
          value: 7,
          label: "养生卡权益券 ",
        },
      ],
      statusOptions: [
        {
          value: 0,
          label: "全部",
        },
        {
          value: 1,
          label: "正常",
        },
        {
          value: 2,
          label: "已禁用",
        },
        {
          value: 3,
          label: "已停发",
        },
        {
          value: 4,
          label: "已过期",
        },
      ],
      searchForm: {
        coupon_name: "",
        coupon_type: "",
        status: 0,
      },
      tableHeader: [
        {
          label: "排序",
          prop: "sort",
          width: "100",
          align: "center",
          fixed: "left",
        },
        {
          label: "优惠券名称",
          prop: "coupon_name",
          width: "100",
          align: "center",
          fixed: false,
        },
        {
          label: "创建时间",
          prop: "create_time",
          width: "140",
          align: "center",
          fixed: false,
        },
        {
          label: "使用条件",
          prop: "message",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "领取日期",
          prop: "show_time",
          width: "200",
          align: "center",
          fixed: false,
        },
        {
          label: "剩余发放总数",
          prop: "total",
          width: "120",
          align: "center",
          fixed: false,
        },
        {
          label: "领取上限",
          prop: "max_get_num",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "已领取总数",
          prop: "receive_total",
          width: "100",
          align: "center",
          fixed: false,
        },
        {
          label: "已使用总数",
          prop: "use_total",
          width: "100",
          align: "center",
          fixed: false,
        },
        {
          label: "是否可分享",
          prop: "is_share",
          width: "100",
          align: "center",
          fixed: "right",
        },
        {
          label: "状态",
          prop: "is_overdue",
          width: "auto",
          align: "center",
          fixed: "right",
        },
        {
          label: "停发状态",
          prop: "is_send",
          width: "auto",
          align: "center",
          fixed: "right",
        },
        {
          label: "禁用状态",
          prop: "coupon_status",
          width: "auto",
          align: "center",
          fixed: "right",
        },
      ],
      diagnosisCouponData: [],
      couponVisible: false,
      couponVisibleTableLoading: false,
      couponVisibleForm: {
        coupon_name: "",
        get_type: "",
        used: "",
        phone: "",
      },
      couponVisibleTotalNum: 0,
      couponVisiblePagination: {
        page: 1,
        pageNumber: 10,
      },
      couponVisibleTableHeader: [
        {
          label: "优惠券名称",
          prop: "coupon_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "领取用户名称",
          prop: "nick_name",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "领取用户手机号",
          prop: "phone",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "领取时间",
          prop: "get_time",
          width: "160",
          align: "center",
          fixed: false,
        },
        {
          label: "领取来源",
          prop: "get_type",
          width: "150",
          align: "center",
          fixed: false,
        },
        {
          label: "优惠券当前状态",
          prop: "used",
          width: "120",
          align: "center",
          fixed: "right",
        },
      ],
      couponVisibleTableData: [],
      getTypeOptions: [
        {
          value: 1,
          label: "自主领取",
        },
        {
          value: 2,
          label: "积分兑换",
        },
        {
          value: 3,
          label: "养生卡赠送",
        },
        {
          value: 4,
          label: "分享领取",
        },
        {
          value: 5,
          label: "引流流动赠送",
        },
        {
          value: 6,
          label: "平台发放",
        },
        {
          value: 7,
          label: "邀请用户赠送",
        },
        {
          value: 8,
          label: "新用户赠送",
        },
        {
          value: 9,
          label: "医生赠送",
        },
        {
          value: 10,
          label: "券包领取",
        },
        {
          value: 11,
          label: "券包发放",
        },
        {
          value: 12,
          label: "VIP陪诊赠送",
        },
      ],
      usedOptions: [
        {
          value: 0,
          label: "未使用",
        },
        {
          value: 1,
          label: "已使用",
        },
        {
          value: 2,
          label: "已失效",
        },
      ],

      sendLogVisible: false,
      sendLogVisibleTableLoading: false,
      sendLogVisibleForm: {
        coupon_data_id: "",
        coupon_name: "",
        time: "",
        send_content: "",
      },
      sendLogVisibleTotalNum: 0,
      sendLogVisiblePagination: {
        page: 1,
        pageNumber: 10,
      },
      sendLogVisibleTableHeader: [
        {
          label: "优惠券名称",
          prop: "coupon_name",
          width: "auto",
          align: "center",
          fixed: "left",
        },
        {
          label: "发放时间",
          prop: "create_time",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "发放对象",
          prop: "send_type",
          width: "auto",
          align: "center",
          fixed: false,
        },
        {
          label: "发放人",
          prop: "send_content",
          width: "260",
          align: "center",
          fixed: false,
        },
        {
          label: "发放操作人",
          prop: "admin_name",
          width: "auto",
          align: "center",
          fixed: "right",
        },
      ],
      sendLogVisibleTableData: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    dateTimeFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm");
    },
    totalText(val) {
      switch (val) {
        case -1:
          return "无限制";
        default:
          return val;
      }
    },
    maxGetNumText(val) {
      switch (val) {
        case 0:
          return "无限制";
        default:
          return val;
      }
    },
    isOverdueText(val) {
      switch (val) {
        case 0:
          return "正常";
        case 1:
          return "已过期";
      }
    },
    isEendText(val) {
      switch (val) {
        case 0:
          return "已停发";
        case 1:
          return "正常";
      }
    },
    send_typeText(val) {
      switch (val) {
        case 1:
          return "医生";
        case 2:
          return "用户";
      }
    },
    couponStatusText(val) {
      switch (val) {
        case 0:
          return "已禁用";
        case 1:
          return "正常";
      }
    },
    usedText(val) {
      switch (val) {
        case 0:
          return "未使用";
        case 1:
          return "已使用";
        case 2:
          // expire_time
          return "已过期";
      }
    },
    getTypeText(val) {
      switch (val) {
        case 1:
          return "自主领取";
        case 2:
          return "积分兑换";
        case 3:
          return "养生卡赠送";
        case 4:
          return "分享领取";
        case 5:
          return "引流流动赠送";
        case 6:
          return "平台发放";
        case 7:
          return "邀请用户赠送";
        case 8:
          return "新用户赠送";
        case 9:
          return "医生赠送";
        case 10:
          return "券包领取";
        case 11:
          return "券包发放";
        case 12:
          return "VIP陪诊赠送";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let params = Object.assign({}, this.pagination, this.searchForm);
      this.tableLoading = true;
      marketing.getCounponLists(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.diagnosisCouponData = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    seachEnterFun(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.getList();
      }
    },
    // 排序
    updateCouponSort(row) {
      let { coupon_data_id, sort } = row;
      marketing.updateCouponSort({ coupon_data_id, sort }).then((res) => {
        let { code } = res;
        if (code === 0) {
          this.$message.success("修改成功");
          this.getList();
        }
      });
    },
    // 发放
    issueBtn(coupon_data_id) {
      this.$router.push({
        path: "/home/marketing/diagnosisCouponIssue",
        query: {
          coupon_data_id,
        },
      });
    },
    // 添加
    addOrEditBtn(type, coupon_data_id) {
      this.$router.push({
        path: "/home/marketing/diagnosisCouponDetail",
        query: {
          type,
          coupon_data_id,
        },
      });
    },
    // 恢复/停发
    isSendBtn(type, row) {
      let { coupon_data_id, is_send } = row;
      let text =
        type == 1
          ? "确认要恢复当前优惠券吗？"
          : "优惠券停发后用户将不再领取/兑换/主动发放。确认要停发当前优惠券吗？";
      let params = {
        coupon_data_id,
        is_send: !is_send ? 1 : 0,
      };
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          marketing.updateCouponSend(params).then((res) => {
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    // 启用/禁用
    isUseBtn(type, row) {
      let { coupon_data_id, coupon_status } = row;
      let text =
        type == 1
          ? "确认要启用当前优惠券吗？"
          : "优惠券禁用后用户将不再领取/兑换/主动发放，且已领取的优惠券也不可使用。确认要禁用当前优惠券吗？";

      let params = {
        coupon_data_id,
        coupon_status: !coupon_status ? 1 : 0,
      };
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          marketing.updateCouponStatus(params).then((res) => {
            if (res.code == 0) {
              this.$message.success("修改成功");
              this.getList();
            }
          });
        })
        .catch(() => {});
    },
    restBtn() {
      for (let key in this.searchForm) {
        if (key == "status") {
          this.searchForm[key] = 0;
        } else {
          this.searchForm[key] = "";
        }
      }
      this.getList();
    },
    // 用户领取优惠券详情
    getUserCouponList() {
      let params = Object.assign(
        {},
        this.couponVisiblePagination,
        this.couponVisibleForm
      );
      this.couponVisibleTableLoading = true;
      marketing.getUserCouponList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.couponVisibleTableData = data.list;
          this.couponVisibleTotalNum = data.total;
          this.couponVisibleTableLoading = false;
        }
      });
    },
    searchCouponVisibleList() {
      this.couponVisiblePagination.page = 1;
      this.getUserCouponList();
    },

    toDetails(row, type) {
      // type : 1领取 2使用
      let { coupon_name } = row;
      this.couponVisibleForm.coupon_name = coupon_name;
      this.couponVisibleForm.get_type = "";
      this.couponVisibleForm.used = type == 1 ? "" : 1;
      this.couponVisible = true;
      this.getUserCouponList();
    },
    // 发放记录
    lookLog(row) {
      let { coupon_data_id, coupon_name } = row;
      this.sendLogVisibleForm.coupon_data_id = coupon_data_id;
      this.sendLogVisibleForm.coupon_name = coupon_name;
      this.sendLogVisible = true;
      this.couponDataSendLog();
    },
    couponDataSendLog() {
      let params = Object.assign(
        {},
        this.sendLogVisiblePagination,
        this.sendLogVisibleForm
      );
      params = _.omit(params, ["time"]);
      let time = this.sendLogVisibleForm.time;
      params.start_time = time ? time[0] : "";
      params.end_time = time ? time[1] : "";
      this.sendLogVisibleTableLoading = true;
      marketing.couponDataSendLog(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.sendLogVisibleTableData = data.list;
          this.sendLogVisibleTotalNum = data.total;
          this.sendLogVisibleTableLoading = false;
        }
      });
    },
    searchsendLogVisibleList() {
      this.sendLogVisiblePagination.page = 1;
      this.couponDataSendLog();
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.diagnosis-coupon {
  .top-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search-box {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
    .item {
      height: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 6px;
      span {
        display: inline-block;
        margin-right: 4px;
        text-align: right;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
    .item-content {
      // width: 100%;
      .el-date-editor {
        width: 100%;
      }
    }
  }
}
</style>
